import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {authenticatedGuard} from './common/auth';

@NgModule({
  imports: [RouterModule.forRoot([
    {
      path: '', pathMatch: 'full', canActivate: [authenticatedGuard],
      loadChildren: () => import('./dashboard')
    },
    {
      path: 'job', canActivate: [authenticatedGuard],
      loadChildren: () => import('./job')
    },
    {
      path: 'tools', canActivate: [authenticatedGuard],
      loadChildren: () => import('./tools')
    },
    {
      path: 'customer', canActivate: [authenticatedGuard],
      loadChildren: () => import('./customer')
    }
  ], {onSameUrlNavigation: 'reload'})],
  providers: [],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
